import { render, staticRenderFns } from "./CarouselScreen.vue?vue&type=template&id=80905552&scoped=true&"
import script from "./CarouselScreen.vue?vue&type=script&lang=js&"
export * from "./CarouselScreen.vue?vue&type=script&lang=js&"
import style0 from "./CarouselScreen.vue?vue&type=style&index=0&id=80905552&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80905552",
  null
  
)

export default component.exports